import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getRemittanceList,getRemittanceEstimates,getRemittanceDetails,getEstimateDetails,changeRemittanceStatus,updateAdjustment,deleteAdjustment,regenerateRemittance,sendRemittanceMail} from "../actions/account_remittance_action";

export default function AccountRemittanceContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getRemittanceList,getRemittanceEstimates,getRemittanceDetails,getEstimateDetails,changeRemittanceStatus,updateAdjustment,deleteAdjustment,regenerateRemittance,sendRemittanceMail}, dispatch);
}

function mapStateToProps(state) {
    return {
        remittances:state.accountRemittance.remittances,
        estimates:state.accountRemittance.estimates,
        isFetching:state.accountRemittance.isFetching,
        remittanceDetail:state.accountRemittance.remittanceDetail,
        estimateDetail:state.accountRemittance.estimateDetail
    };
}



// WEBPACK FOOTER //
// ./src/containers/account_remittance_container.js